import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../../providers/global/global';

declare var google;

@IonicPage()
@Component({
  selector: 'page-gauge',
  templateUrl: 'gauge.html',
})
export class GaugePage {
  tag: string;
  valor: string;
  timestamp: string;
  tag2: string;
  valor2: string;
  timestamp2: string;
  ue: string;
	data: Observable<any>;
	myTag: string;
	isRefreshing: boolean = false;
	refresher: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public global: GlobalProvider,
  ) {
/*
    setInterval(() => {
          this.myTag = "temp_amb";
          this.carregaValor();
    }, 60000);
*/
  }

  doRefresh(refresher) {
    this.refresher = refresher;
    this.isRefreshing = true;
    this.myTag = "temp_amb";
    this.carregaValor();
  }

  post()
  {
    this.carregaValor();
  }

  ionViewDidEnter(){
    this.myTag = "temp_amb";
    this.carregaValor();
    this.teste();
  }

  public carregaValor(): void
  {
    var url='http://iot.digicomp.com.br/api/public/ping/ultimo_valor';
    this.global.check_jwt();

    let body=new FormData();
    body.append('db','senac');
    body.append('tabela','senac_mg');
    body.append('tag', this.myTag);
    body.append('jwt', this.global.token);

    try
    {
      this.data=this.http.post(url,body);
      this.data.subscribe(data=>{
        var value = Number.parseFloat(data.valor).toFixed(2);
        //console.log(data);
        this.tag = "Tag: "+data.tag;
        this.valor = "Valor: "+value+" "+data.ue;
        this.timestamp = "Timestamp: "+data.timestamp;

        document.getElementById("temp").innerHTML = data.tag
        var dataGauge = google.visualization.arrayToDataTable([
             ['Label', 'Value'],
             ['°C', parseFloat(value)]
           ]);

           var options = {
             width: 300, height: 220,
             min: 10,
             max: 30,
             yellowFrom: 25, yellowTo: 27.5,
             redFrom: 27.5, redTo: 30,
             minorTicks: 5,
             majorTicks:['10','15','20','25','30']
           };

           var chart = new google.visualization.Gauge(document.getElementById('chart_div'));

           chart.draw(dataGauge, options);
      });
    }
    catch(err)
    {
      document.getElementById("demo").innerHTML = err.message;
    }

    if (this.isRefreshing){
      setTimeout(() => {
      this.refresher.complete();
      this.isRefreshing = false;
    }, 500);
    }
  }

  public teste(): void
  {
    var url='http://iot.digicomp.com.br/api/public/ping/ultimo_valor';
    this.global.check_jwt();

    let body=new FormData();
    body.append('db','senac');
    body.append('tabela','senac_mg');
    body.append('tag', 'AP1_Humidity');
    body.append('jwt', this.global.token);

    try
    {
      this.data=this.http.post(url,body);
      this.data.subscribe(data=>{
        var value = Number.parseFloat(data.valor).toFixed(2);
        //console.log(data);
        this.tag2 = "Tag: "+data.tag;
        this.valor2 = "Valor: "+value+" "+data.ue;
        this.timestamp2 = "Timestamp: "+data.timestamp;

        document.getElementById("umid").innerHTML = data.tag
        var dataGauge = google.visualization.arrayToDataTable([
             ['Label', 'Value'],
             ['', parseFloat(value)]
           ]);

           var options = {
             width: 300, height: 220,
             min: 10,
             max: 90,
             yellowFrom: 20, yellowTo: 30,
             redFrom: 10, redTo: 20,
             minorTicks: 5,
             majorTicks:['10','30','50','70','90']
           };

           var chart = new google.visualization.Gauge(document.getElementById('chart2_div'));

           chart.draw(dataGauge, options);
      });
    }
    catch(err)
    {
      document.getElementById("demo").innerHTML = err.message;
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/gauge/gauge.ts